import React from 'react';
import {convertISODateTimeToBRLocale} from "../../../common/Util";


const ReactHighcharts = require('react-highcharts');
//var Moment = require('moment-timezone');
//require('moment/locale/pt-br');

class AutoclaveCicloGraficoPresets extends React.Component {
    constructor(props) {
        super(props);
        this.state={};
    };


    componentDidMount(){
        //   this.props.getItensManual();

    }

    componentDidUpdate(oldProps, oldState){

      //  console.log('didUpdate')
    }




    render() {
        const { ciclo } = this.props;
        const { isOpen } = this.state;

        console.log("indicador ciclo presets", ciclo);

        if (!ciclo || ciclo.length < 1) { return null; }



        var chartdata = {
            chart: {
                type: 'line',
                zoomType: 'xy',
                animation: false
            },
            legend: {
                enabled : true
            },
            title: {
                text: ''
            },
            xAxis: {
                categories: ciclo.categoria,
                title: {
                    text: 'Tempo em minutos do Processo - Vulcanização - '
                }
            },
            yAxis: {

                title: {
                    text : ''
                },
                categories:[
                    'Receita',
                    'presetTemperaturaAutoclave',
                    'presetPressaoAutoclave',
                    'presetPressaoEnvelope',
                    'presetPressaoInicialEnvelope',
                    'presetAntecipacaoDescargaSacoDeAr',
                    'presetPressaoSacoDeAr',
                    'presetTempoVulcanizacao',
                    'presetTempoSupervisaoPressoes',
                    'presetTempoSupervisaoAquecimento'
                ]
            },
            series : [
                {
                    name : "receitaNumero",
                    data : ciclo.receitaNumero
                },
                {
                    name : "presetTemperaturaAutoclave",
                    data : ciclo.presetTemperaturaAutoclave
                },
                {
                    name : "presetPressaoAutoclave",
                    data : ciclo.presetPressaoAutoclave
                },
                {
                    name : "presetPressaoEnvelope",
                    data: ciclo.presetPressaoEnvelope
                },
                {
                    name : "presetPressaoInicialEnvelope",
                    data: ciclo.presetPressaoInicialEnvelope
                },
                {
                    name : "presetAntecipacaoDescargaSacoDeAr",
                    data: ciclo.presetAntecipacaoDescargaSacoDeAr
                },
                {
                    name : "presetPressaoSacoDeAr",
                    data: ciclo.presetPressaoSacoDeAr
                },
                {
                    name : "presetTempoVulcanizacao",
                    data: ciclo.presetTempoVulcanizacao
                },
                {
                    name : "presetTempoSupervisaoPressoes",
                    data: ciclo.presetTempoSupervisaoPressoes
                },
                {
                    name : "presetTempoSupervisaoAquecimento",
                    data: ciclo.presetTempoSupervisaoAquecimento
                }


            ]
        }


        return (
            <React.Fragment>

                <ReactHighcharts config = {chartdata}></ReactHighcharts>


            </React.Fragment>
        )
    }
}



export default AutoclaveCicloGraficoPresets

